import { useQuery } from "@apollo/client";
import { VALIDATE_PFML_1250_MINIMUM_REQUIRED_HOURS } from "../Queries";

export function usePfml1250MinimumRequiredHours(workState?: string){
    return useQuery(VALIDATE_PFML_1250_MINIMUM_REQUIRED_HOURS, {
        variables: {
            workState: workState
        },
        skip: !workState
    })
}